import Typography, { TypographyProps } from './Typography';

export type { TypographyProps };
export default Typography;
